import React, {PropTypes} from 'react';
import _ from 'lodash';
import {uploadFile} from 'app/lib/ajax';
import FileInput from './FileInput';
import Button from '../Button';
import Preloader from '../Preloader';


class FileUpload extends React.Component {

    static propTypes = {
        buttonText: PropTypes.string,
        uploadText: PropTypes.node,
        cancelText: PropTypes.node,
        uploadUrl: PropTypes.string.isRequired,
        onFileUploadSuccess: PropTypes.func,
        onFileUploadFail: PropTypes.func,
        errorMessage: PropTypes.node
    };

    static defaultProps = {
        uploadText: 'Upload',
        cancelText: 'Cancel'  
    };

    state = {
        file: null,
        pending: false,
        message: null
    };

    fileInputChangedHandler = (file) => {
        this.setState({file, pending:false, message: null});
    };

    uploadDocument = () => {
        const {onFileUploadSuccess, onFileUploadFail, uploadUrl} = this.props;
        let data = new FormData();
        data.append('file', this.state.file);

        this.setState({
            pending: true
        });

        uploadFile(uploadUrl, data)
            .then((response) => {
                if (response.status > 299) {
                    this.setState({pending: false});
                    throw Error(response.statusText);
                }
                response.file = this.state.file;
                this.setState({
                    pending: false,
                    file: null
                });
                return response;
            })
            .then(onFileUploadSuccess || _.noop)
            .catch((err) => {
                this.setState({pending: false, message: this.props.errorMessage});
                if (onFileUploadFail) {
                    onFileUploadFail(err);
                }
            });
    };

    clearFile = () => {
        this.setState({file:null});
    };

    render() {
        return (
            <div>
                <FileInput onChange={this.fileInputChangedHandler} buttonText={this.props.buttonText} file={this.state.file} />
                {this.state.file && (this.state.pending ? <Preloader /> : <div>
                    <Button onClick={this.uploadDocument}>{this.props.uploadText}</Button>
                    {' '}
                    <Button onClick={this.clearFile} flat>{this.props.cancelText}</Button>
                </div>)}
                {this.state.file && this.state.message && <div className="msg-error">{this.state.message}</div>}
            </div>
        );
    }    
}

export default FileUpload;